import React from 'react';
import { LinkContainer, StyledLink, StyledListItem } from './ShowLinks.styles';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShowLinks = ({
  links
}) => {
  const analytics = useAnalyticsDispatch();
  const getLink = link => /*#__PURE__*/_jsx(StyledListItem, {
    children: /*#__PURE__*/_jsx(StyledLink, {
      to: link.link,
      text: link.title,
      showDefaultIcon: true,
      onClick: () => {
        analytics({
          type: 'click-event',
          name: 'ShowLink',
          value1: link.title,
          value2: link.link
        });
      }
    })
  }, `${link.title}-${link.link}`);
  return !!links.length && /*#__PURE__*/_jsx(LinkContainer, {
    children: links.map(getLink)
  });
};